/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetCourseCompletionsReportAggregateByDayOptions, GetCourseCompletionsReportAggregateByDayResponses } from '../../models/GetCourseCompletionsReportAggregateByDay'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Course Completions Aggregate By Day
 * {@link /reports/course_completions/aggregate-by-day}
 */
export function getCourseCompletionsReportAggregateByDay<ThrowOnError extends boolean = true>(options: Options<GetCourseCompletionsReportAggregateByDayOptions, ThrowOnError>): Promise<UnwrappedResult<GetCourseCompletionsReportAggregateByDayResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/reports/course_completions/aggregate-by-day', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetCourseCompletionsReportAggregateByDayResponses, ThrowOnError>>
}
